import { EXPLICIT_NULLABLE_PROPERTY_STRING_KEYS } from "./propertyAlternativeContact";
import { COMMISSION_NULLABLE_PAYLOAD_KEYS } from "./propertyCommission";

/**
 * Builds a PUT /draft body from form values: drops null/NaN/empty junk that
 * Laravel rejects with 422 on incomplete pré-cadastro updates.
 */
const SENSITIVE_DRAFT_KEYS = new Set(["key_location_password"]);

const POSITIVE_ID_KEYS = new Set([
  "user_id",
  "partner_broker_id",
  "consultant_id",
  "finder_id",
  "key_location_id",
  "address_id",
  "property_type_id",
]);

export function sanitizeDraftUpdatePayload(
  payload: Record<string, unknown>
): Record<string, unknown> {
  const result: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(payload)) {
    if (SENSITIVE_DRAFT_KEYS.has(key)) continue;

    if (COMMISSION_NULLABLE_PAYLOAD_KEYS.has(key)) {
      if (value === null) {
        result[key] = null;
        continue;
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        result[key] = trimmed === "" ? null : trimmed;
        continue;
      }
      if (typeof value === "number" && Number.isFinite(value)) {
        result[key] = value;
        continue;
      }
      continue;
    }

    if (EXPLICIT_NULLABLE_PROPERTY_STRING_KEYS.has(key)) {
      if (value === null) {
        result[key] = null;
        continue;
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        result[key] = trimmed === "" ? null : trimmed;
        continue;
      }
    }

    if (value === undefined || value === null) continue;
    if (typeof value === "number" && !Number.isFinite(value)) continue;
    if (
      POSITIVE_ID_KEYS.has(key) &&
      (typeof value !== "number" || value <= 0)
    ) {
      continue;
    }
    if (typeof value === "string" && value.trim() === "") continue;
    if (Array.isArray(value) && value.length === 0) continue;
    result[key] = value;
  }

  return result;
}

/** Currency inputs store integer cents as a digit string (e.g. "150000" → 1500). */
export function parseDraftMoneyInput(raw: unknown): number | undefined {
  if (raw == null || raw === "") return undefined;

  const asString = String(raw).replace(/\D/g, "");
  if (!asString) return undefined;

  const cents = Number(asString);
  if (!Number.isFinite(cents)) return undefined;

  return Number(
    `${asString.substring(0, asString.length - 2)}.${asString.substring(
      asString.length - 2,
      asString.length
    )}`
  );
}
